import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RootState, useAppSelector } from "../../../../src/app/store";
import { getFeatureFlags } from "../../configs/logic/Slice";
import Spinner from "../../../components/ui/spinners/CompactLoadingSpinner";

interface FeatureProtectedRouteProps {
  selector: (state: RootState) => boolean;
  fallbackPath: string;
}

const FeatureProtectedRoute: React.FC<FeatureProtectedRouteProps> = ({
  selector,
  fallbackPath,
}) => {
  const flags = useAppSelector(getFeatureFlags);
  const isEnabled = useAppSelector(selector);

  if (Object.keys(flags).length === 0) {
    return <Spinner isFixed message="Loading..." showDefaultSubtitle={false} />;
  }

  if (!isEnabled) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet />;
};

export default FeatureProtectedRoute;
